import { useToast } from "@chakra-ui/react" ;
import { useMemo } from "react";

import { ConsumptionsBox } from "@components/ConsumptionsBox/ConsumptionsBox";
import { useAuthContext } from "@hooks/useAuthContext";
import { ConsumptionScope, useConsumptions } from "@hooks/useConsumptions";
import { defaultErrorToast } from "@utils/toast" ;

interface ConsumptionsTabProps {
    shownCorporationData?: boolean;
}

export const ConsumptionsTab = (props: ConsumptionsTabProps) => {
    const { shownCorporationData = false } = props;
    const { connectedUser } = useAuthContext();
    const corporation = connectedUser?.corporations?.first();
   const scope = useMemo<ConsumptionScope>(
        () => (shownCorporationData ? { type: "corporation", corporationId: corporation?.apid, corporationName: corporation?.name } : { type: "mine" }),
        [shownCorporationData]
    );
    const { nbFrees, nbPaid, nbRefused, inProgress, lastyearConsumptions, exportFileConsumptions } = useConsumptions(connectedUser, scope);
    const toast = useToast();

    const onExportConsumptions = async () => {
        try {
            await exportFileConsumptions();
        } catch (error) {
            toast(defaultErrorToast("Problème rencontré lors de l'export des données"));
        }
    };

    return (
        <ConsumptionsBox currentMonth={{ nbFrees, nbPaid, nbRefused, inProgress }} allConsumptions={lastyearConsumptions} onExport={onExportConsumptions} />   
    );
};